function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8008 3.2002L3.20084 12.8001",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8008 12.7998L3.20084 3.19986",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGrey);
export default __webpack_public_path__ + "static/media/crossGrey.0cd3a1bb6652f5b440d671b17e8a781e.svg";
export { ForwardRef as ReactComponent };